import { Module } from "../../types/Module";
import { ModuleAction, ModuleActionType } from "../actions/moduleAction";

const initialState: Module[] = [];

export const moduleReducer = (
  state = initialState,
  action: ModuleAction,
): Module[] => {
  switch (action.type) {
    case ModuleActionType.FETCH_MODULES:
      return action.data;
    case ModuleActionType.FETCH_MODULES_PROJECTID:
      return action.data;
    case ModuleActionType.ADD_MODULE:
      return [...state, action.data];
    case ModuleActionType.EDIT_MODULE:
      return state.map((mod) =>
        mod.id === action.data.id ? action.data : mod,
      );
    case ModuleActionType.DELETE_MODULE:
      return state.filter((mod) => mod.id !== action.data);
    default:
      return state;
  }
};
